import { FETCH_ADD_PRODUCT_SUCCESS, FETCH_ADD_PRODUCT_RESET } from '../actionTypes';

export const saveproduct = (productID) => {
    return async function (dispatch, getState) {
    dispatch({
        type: FETCH_ADD_PRODUCT_SUCCESS,
        payload: {productID},
    });
    }
};

export const resetproduct = () => {
    return async function (dispatch, getState) {
    dispatch({
        type: FETCH_ADD_PRODUCT_RESET,
    });
    }
};
